const ColorBox = ({ color }) => {
    const boxStyle = {
      backgroundColor: color,
      width: '100px',
      height: '40px',
      borderRadius: '10px', // This gives the div rounded corners
      display: 'inline-block',
    };
  
    return <div style={boxStyle}></div>;
  };

  export default ColorBox;